import React from "react";

export const Camera = (): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="true"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 18 18"
    >
      <path
        fillRule="evenodd"
        d="M3.258 3.594a1.5 1.5 0 011.99-.657L16.411 8.39a2.986 2.986 0 01-.69.45c-.241.104-.4.11-.5.085L10.57 6.587a.75.75 0 10-.673 1.34L12.17 9.07l-1.516 2.862L4.828 9.06a2.112 2.112 0 01-1.14-2.292l1.765.86a.75.75 0 10.658-1.347L2.72 4.627l.537-1.033zm-.946 2.502l-.939-.458a.75.75 0 01-.337-1.02l.89-1.715a3 3 0 013.98-1.314l11.26 5.5c.814.398 1.193 1.57.37 2.311-.332.298-.75.611-1.214.814a2.961 2.961 0 01-.27.103.75.75 0 01-.083.476l-1.419 2.579a.75.75 0 01-.999.306l-1.672-.855-.241.455a.75.75 0 01-.994.322l-2.566-1.265-1.162 1.538a2.017 2.017 0 01-3.373 2.136H.754a.75.75 0 010-1.5h2.314a2.017 2.017 0 012.759-1.682l.881-1.168-2.543-1.254a3.612 3.612 0 01-1.853-4.309zm10.27 5.401l.665-1.255 1.03.513-.69 1.256-1.005-.514zm-7.506 2.686a.517.517 0 100 1.033.517.517 0 000-1.033z"
        clipRule="evenodd"
      />
    </svg>
  );
};
